import React, { useMemo, useEffect, useState } from 'react';
import moment from 'moment';

import { useFunction } from '@laigu/store';

import EventIcon from './event-icon';

import styles from './index.less';

const EventAgentRedirect = props => {

  const { data, handleGptSummary } = props;
  const { action, content, time, show_summary_btn = false, ended = false, id: eventId, convId, listType = '' } = data;

  const transEventId = Number(eventId);

  const hasConvRedirectSummaryFun = useFunction('conv_redirect_summary');

  const gptSummaryMsgIds = localStorage.getItem('gptSummaryMsgIds') || [];

  const [hasSummaried, setHasSummaried] = useState(gptSummaryMsgIds.includes(transEventId) || false);
  const [flag, setFlag] = useState(false);
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  const redirectTime = `${moment.utc(time).format('YYYY-MM-DDTHH:mm:ss')}Z`;

  /**
   * 对话总结
   * 1. 显示逻辑
   *  1.1 转接到是当前登录用户
   *  1.2 会话状态为未结束
   *  1.3 当前正在请求，不显示【将当前正在的请求的对话的id放在缓存中】
   *  1.4 含有对话总结的功能
   * 2. 暂时不做点击控制, 后端做点击计算频率
   */
  const handleSummary = async () => {
    if (convId && transEventId && handleGptSummary) {
      setFlag(true);
      await handleGptSummary(convId, transEventId, redirectTime);
      setFlag(false);
    }
  };

  const innerShowSummaryBtn = useMemo(() => {
    return show_summary_btn && !ended && !hasSummaried && hasConvRedirectSummaryFun && listType === 'mine';
  }, [show_summary_btn, ended, hasSummaried, hasConvRedirectSummaryFun, listType, flag]);

  useEffect(() => {
    const gptSummaryMsgIds1 = localStorage.getItem('gptSummaryMsgIds') || [];
    setHasSummaried(gptSummaryMsgIds1.includes(transEventId) || false);
  }, [flag]);

  return (
    <div className={styles['event-box']}>
      <ul className={styles.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={styles.date}>{date}</li>
        <li>{content}</li>
        {innerShowSummaryBtn && (
          <li className={styles.summary_btn} onClick={handleSummary}>
            {'对话总结'}
          </li>
        )}
      </ul>
    </div>
  );
};

export default EventAgentRedirect;
